import { DateString } from "../types";

/**
 * Funnel state of a peer the logged-in expert referred to a project.
 * Flow: invited (invite sent) -> joined (peer created an account) -> paid
 * (peer completed a first call and the $100 referral was earned).
 */
export enum EXPERT_REFERRAL_FUNNEL_STATUS {
  INVITED = "Invited",
  JOINED = "Joined",
  PAID = "Paid"
}

export type ExpertReferralFunnelStatus = `${EXPERT_REFERRAL_FUNNEL_STATUS}`;

/**
 * A single row on the expert Referrals page: an invitation email the expert
 * sent to refer a peer to a project, with the current funnel status and
 * the created / expiration dates.
 */
export interface ExpertReferralUserInvitationEmail {
  id: string;
  email: string;
  projectId: string | null;
  projectTitle: string;
  status: ExpertReferralFunnelStatus;
  createdDate: DateString;
  expirationDate: DateString | null;
}
